import { createRouter, createWebHistory } from "vue-router";
import App from "../views";
import AuthRequired from "../utils/AuthRequired";
import { useMainStore } from "@/store"
import NotFound from '@/views/NotFound.vue'

const routes = [
  {
    path: "/",
    name: "App",
    component: App,
    beforeEnter: AuthRequired,
    redirect: "/home",
    children: [
      // GLOBAL
      {
        path: "/home",
        name: "Home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "/setor",
        name: "Setor Tabungan",
        component: () => import("../views/parent/Setor.vue"),
        meta: { requiresType3: true },
      },
       {
        path: "/riwayat",
        name: "Riwayat Transaksi",
        component: () => import("../views/HistoryTransaksi.vue"),
      },
      {
        path: "/profile",
        name: "Profile",
        component: () => import("../views/Profile.vue"),
      },
            {
        path: "/detail_transaksi/:id",
        name: "DetailTransaksi",
        component: () => import("../views/DetailTransaksi.vue"),
        props: true,
      },
      // END GLOBAL

      // ADMIN
      {
        path: "/penyerahan",
        name: "Transaksi Setor & Tarik",
        component: () => import("../views/admin/PenyerahanSetorTarik.vue"),
        meta: { requiresType5: true },
      },
        {
        path: "/proses_trans_guru",
        name: "Proses Transaksi Guru",
        component: () => import("../views/admin/VerifTransaksiAdmin.vue"),
        meta: { requiresType5: true },
      },
      // END ADMIN

      // SISWA
      {
        path: "/tarik",
        name: "Tarik Tabungan",
        component: () => import("../views/parent/Tarik.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/transaksi",
        name: "Transaksi",
        component: () => import("../views/parent/Transaksi.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/info_siswa",
        name: "Info",
        component: () => import("../views/parent/InfoMurid.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/akr-play",
        name: "AKR Play",
        component: () => import("../views/parent/AkrPlay.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/kalkulator",
        name: "Kalkulator Target",
        component: () => import("../views/parent/KalkulatorTabungan.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/kalkulator-pendidikan",
        name: "Dana Pendidikan",
        component: () => import("../views/parent/KalkulatorPendidikan.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/buku-jajan",
        name: "Buku Jajan Harian",
        component: () => import("../views/parent/BukuJajan.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/pohon-tabungan",
        name: "Pohon Tabungan",
        component: () => import("../views/parent/PohonTabungan.vue"),
        meta: { requiresType3: true },
      },
      {
        path: "/duel-logika",
        name: "Duel Berhitung",
        component: () => import("../views/parent/DuelLogika.vue"),
        meta: { requiresType3: true },
      },
      // END SISWA

      // GURU
      {
        path: "/verif_transaksi",
        name: "Verif Transaksi",
        component: () => import("../views/teacher/VerifTransaksi.vue"),
        meta: { requiresType2: true },
      },
      {
        path: "/info_guru",
        name: "Kelas",
        component: () => import("../views/teacher/InfoGuru.vue"),
        meta: { requiresType2: true },
      },
      // END GURU

      // staff
      {
        path: "/riwayat_transaksi",
        name: "Riwayat Trans",
        component: () => import("../views/staff/RiwayatTransaksi.vue"),
        meta: { requiresType4: true },
      },
      {
        path: "/verif_setoran_tabungan",
        name: "Verif Setoran Tabungan",
        component: () => import("../views/staff/VerifCollect.vue"),
        meta: { requiresType4: true },
      },
      {
        path: "/verif_petugas",
        name: "Verifikasi Transaksi",
        component: () => import("../views/staff/ScanPage.vue"),
        meta: { requiresType4: true },
      },
      // END STAFF
    ],
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: () => import("../views/Welcome.vue"),
  },
  {
    path: "/404",
    name: "Halaman Tidak Ditemukan",
    component: () => import("../views/NotFound.vue"),
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/404"
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
    beforeEnter: AuthRequired,
  },
  {
    path: "/forgot-password",
    name: "Forgot Password",
    component: () => import("../views/ForgotPassword.vue"),
    beforeEnter: AuthRequired,
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () => import("../views/ResetPassword.vue"),
    beforeEnter: AuthRequired,
  },
  {
    path: "/logout",
    name: "Logout",
    component: () => import("../views/Logout.vue"),
    beforeEnter: AuthRequired,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useMainStore();

  if (to.path !== from.path) {
    store.startLoading();
  }

  if (to.meta.requiresType5 && store.user?.type !== 5) {
    return next({ path: '/404' })
  }
  if (to.meta.requiresType4 && store.user?.type !== 4) {
    return next({ path: '/404' })
  }
  if (to.meta.requiresType3 && store.user?.type !== 3) {
    return next({ path: '/404' })
  }
  if (to.meta.requiresType2 && store.user?.type !== 2) {
    return next({ path: '/404' })
  }

  next();
});

router.afterEach(() => {
  const store = useMainStore();
  setTimeout(() => {
    store.stopLoading();
  }, 200);
});


export default router;
